const initialState = () => ({
  settings: {
    item_responsabilities: []
  },
  workingHours: {
    active: false,
    days: []
  }
})

export default initialState
